import React from "react";
import leftArrow from "../assets/icons/left-arrow.svg";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

function Cooperation() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="global-component">
            <div className="jackpot_title">
                <img src={leftArrow}
                    alt="icon"
                    width={32}
                    height={32}
                    onClick={() => {
                        navigate('/more')
                    }}
                />
                <span>{t('Сотрудничество')}</span>
            </div>
            <div className="global-component_item">
                <div className="global-component_item__title">
                    1.{t('Партнёрские программы')}
                </div>
                <div className="global-component_item__content">
                    <ul>
                        <li>{t('Многоуровневая реферальная система (10% / 5% / 2%)')}</li>
                        <li>{t('Индивидуальные условия для крупных партнёров')}</li>
                    </ul>
                </div>
            </div>

            <div className="global-component_item">
                <div className="global-component_item__title">
                    2. {t('Амбассадорская программа')}
                </div>
                <div className="global-component_item__content">
                    <ul>
                        <li>{t('Поддержка проекта в соцсетях')}</li>
                        <li>{t('Эксклюзивные NFT-награды')}</li>
                        <li>{t('Бонусы за активность и привлечение игроков')}</li>
                    </ul>
                </div>
            </div>

            <div className="global-component_item">
                <div className="global-component_item__title">
                    3. {t('Маркетинг и реклама')}
                </div>
                <div className="global-component_item__content">
                    <ul>
                        <li>{t('Совместные кампании')}</li>
                        <li>{t('Баннеры и промо на сайте')}</li>
                        <li>{t('Взаимная интеграция с проектами в сфере крипто')}</li>
                    </ul>
                </div>
            </div>

            <div className="global-component_item">
                <div className="global-component_item__title">
                    4. {t('Инвестиции и партнёрство')}
                </div>
                <div className="global-component_item__content">
                    <ul>
                        <li>{t('Возможность раннего участия в токенсейле')}</li>
                        <li>{t('Закрытые клубы и ивенты для партнёров')}</li>
                    </ul>
                </div>
                <a
                    href="mailto:lottowin777online@gmail.com"
                    className="global-component_item__content"
                >
                    {t("Для связи: ")} lottowin777online@gmail.com
                </a>
            </div>

        </div>
    )
}

export default Cooperation